import { GET_USER_PROFILE, USERS_ERROR, USER_PROFILE_UPDATE } from "../types";

const initialState = {
    response: null,
    loading: true,
    create: false,
    detail: false,
};

export default function userProfileDataStore(state = initialState, action) {
    switch (action.type) {
        case USER_PROFILE_UPDATE:
            return {
                ...state,
                detail: false,
                create: true,
                response: action.payload,
            };
        case GET_USER_PROFILE:
            return {
                ...state,
                create: false,
                detail: true,
                response: action.payload,
            };
        case USERS_ERROR:
            return {
                ...state,
                detail: true,
                create: true,
                response: action.payload,
            };
        default:
            return state;
    }
}
